export default __webpack_public_path__ + "static/invoice-login-modal-img-82e2761432f80ad4a7a614f79b315e49.png";